import * as React from "react";
import theme from "./theme";
import MainAppBar from "./components/mainappbar";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";
import { Outlet, ScrollRestoration } from "react-router-dom";

export default function App() {
  return (
    <Box>
      <ThemeProvider theme={theme}>
        <MainAppBar />
          <Outlet />
      </ThemeProvider>
      {/* Automatically scrolls to top on new pages, and restores position on back/forward */}
      <ScrollRestoration />
    </Box>
  );
}
